import React, { useState, useEffect, useMemo } from 'react';
import './fonts.css';
import axios from 'axios';


const App = () => {
  //   Initializing variables  //
  const [userEmail, setUserEmail] = useState('');      
  const [organization, setOrganization] = useState(null);
  const [activeTab, setActiveTab] = useState('summary');  
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [isFromSEC, setIsFromSEC] = useState(false);
  const [isFromB12Report, setIsFromB12Report] = useState(false);
  const [isFromB12Archive, setIsFromB12Archive] = useState(false);
  const [isFromB10Report, setIsFromB10Report] = useState(false);
  const [isFromB10Archive, setIsFromB10Archive] = useState(false);  
  const [isFromSECReport, setIsFromSECReport] = useState(false);
  const [isFromSECArchive, setIsFromSECArchive] = useState(false);
  const [isFromCFPReport, setIsFromCFPReport] = useState(false);
  const [isFromCFPArchive, setIsFromCFPArchive] = useState(false);    
  const [isFromACCReport, setIsFromACCReport] = useState(false);
  const [isFromACCArchive, setIsFromACCArchive] = useState(false);        
  const [isKnownUser, setIsKnownUser] = useState(false);
  const [SecDraftComponent, setSecDraftComponent] = useState(null);
  const [CFPDraftComponent, setcfpDraftComponent] = useState(null);
  const [SecPublishComponent, setSecPublishComponent] = useState(null);
  const [SecPublicPublishComponent, setPublicSecPublishComponent] = useState(null);
  const [CFPPublishComponent, setcfpPublishComponent] = useState(null);
  const [CfpPublicPublishComponent, setPubliccfpPublishComponent] = useState(null);  
  const [SecPublicArchiveComponent, setPublicSecArchiveComponent] = useState(null);
  const [CfpPublicArchiveComponent, setPublicCFPArchiveComponent] = useState(null);  
  const [AccPublicPublishComponent, setPublicAccPublishComponent] = useState(null);
  const [AccPublicArchiveComponent, setPublicAccArchiveComponent] = useState(null); 
  const [B12PublicPublishComponent, setPublicB12PublishComponent] = useState(null);
  const [B12PublicArchiveComponent, setPublicB12ArchiveComponent] = useState(null);
  const [B10PublicPublishComponent, setPublicB10PublishComponent] = useState(null);
  const [B10PublicArchiveComponent, setPublicB10ArchiveComponent] = useState(null);  
  const [SecExemptComponent, setSecExemptComponent] = useState(null);
  const [CFPExemptComponent, setcfpExemptComponent] = useState(null);
  const [AccDraftComponent, setAccDraftComponent] = useState(null);
  const [AccPublishComponent, setAccPublishComponent] = useState(null);
  const [AccExemptComponent, setAccExemptComponent] = useState(null);
  const [Big12ExemptComponent, setBig12ExemptComponent] = useState(null);
  const [Big12DraftComponent, setBig12DraftComponent] = useState(null);
  const [Big12PublishComponent, setBig12PublishComponent] = useState(null);
  const [Big10ExemptComponent, setBig10ExemptComponent] = useState(null);
  const [Big10DraftComponent, setBig10DraftComponent] = useState(null);
  const [Big10PublishComponent, setBig10PublishComponent] = useState(null);   
  const [SecSummaryComponent, setSecSummaryComponent] = useState(null);
  const [SecWindowComponent, setSecWindowComponent] = useState(null);
  const [SecArchiveComponent, setSecArchiveComponent] = useState(null);
  const [SecPTComponent, setSecPTComponent] = useState(null);
  const [CFPSummaryComponent, setcfpSummaryComponent] = useState(null);
  const [CFPWindowComponent, setcfpWindowComponent] = useState(null);
  const [CFPArchiveComponent, setcfpArchiveComponent] = useState(null);
  const [CFPPTComponent, setcfpPTComponent] = useState(null);  
  const [AccSummaryComponent, setAccSummaryComponent] = useState(null);
  const [AccWindowComponent, setAccWindowComponent] = useState(null);
  const [AccArchiveComponent, setAccArchiveComponent] = useState(null);
  const [AccPTComponent, setAccPTComponent] = useState(null);
  const [Big12SummaryComponent, setBig12SummaryComponent] = useState(null);
  const [Big12WindowComponent, setBig12WindowComponent] = useState(null);
  const [Big12ArchiveComponent, setBig12ArchiveComponent] = useState(null);
  const [Big12PTComponent, setBig12PTComponent] = useState(null);  
  const [Big10SummaryComponent, setBig10SummaryComponent] = useState(null);
  const [Big10WindowComponent, setBig10WindowComponent] = useState(null);
  const [Big10ArchiveComponent, setBig10ArchiveComponent] = useState(null);
  const [Big10PTComponent, setBig10PTComponent] = useState(null);    
  const [InputFormComponent, setInputFormComponent] = useState(null);
  const [InputFormComponentCFP, setInputFormComponentCFP] = useState(null);
  const [InputFormB12Component, setInputFormB12Component] = useState(null);
  const [ACCInputFormComponent, setACCInputFormComponent] = useState(null);
  const [InputFormB10Component, setInputFormB10Component] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingDraft, setLoadingDraft] = useState(false);
  const [loadingPublish, setLoadingPublish] = useState(false);
  const [loadingExempt, setLoadingExempt] = useState(false);
  const [loadingInput, setLoadingInput] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 450);
  const [dropdownOpen, setDropdownOpen] = useState(false);


//   Confirms the origin website is hdintelligence.com and then grabs the login info from Descope   //
useEffect(() => {
  window.parent.postMessage({ type: "ready", origin: window.location.origin }, "*");
  function handleMessage(event) {
    if (event.origin !== "https://www.hdintelligence.com") {
      console.warn("Blocked message from untrusted origin:", event.origin);
      return;
    }
    const { email } = event.data;
    if (email) {
      setUserEmail(email);
    }
  }
  window.addEventListener("message", handleMessage);
  return () => {
    window.removeEventListener("message", handleMessage);
  };
}, []);

const fetchOrganization = async (userEmail) => {
  try {
    const res = await axios.post('/api/V$3rs1', { userEmail });
    setOrganization(res.data.organization); 
    setLoading(false);
  } catch (err) {
    console.error("Error fetching organization:", err);
    setLoading(false);
  }
};

useEffect(() => {
  if (userEmail) {
    fetchOrganization(userEmail);
  }
}, [userEmail]);

const secOrg = "SEC";
const accOrg = "ACC";
const big12Org = "B12";
const big10Org = "B10";
const cfpOrg = "CFP";

const allowedOrgsB12 = [
"Iowa State",
"Kansas State",
"Cincinnati",
"West Virginia",
"Texas Tech",
"BYU",
"Arizona State",
"Arizona",
"TCU",
"Baylor",
"Colorado",
"Utah",
"UCF",
"Houston",
"Oklahoma State",
"Kansas"  
]

const allowedOrgsB10 = [
"Illinois",
"Indiana",
"Iowa",
"Maryland",
"Michigan",
"Michigan State",
"Minnesota",
"Nebraska",
"Northwestern",
"Ohio State",
"Oregon",
"Penn State",
"Purdue",
"Rutgers",
"UCLA",
"USC", 
"Washington",
"Wisconsin"  
]

const allowedOrgsSEC = [
"Alabama",
"Arkansas",
"Auburn",
"Florida",
"Georgia",
"Kentucky",
"LSU",
"Mississippi State",
"Missouri",
"Ole Miss",
"Oklahoma",
"South Carolina",
"Texas",
"Texas A&M",
"Tennessee",
"Vanderbilt",
"UConn"
]

const allowedOrgsACC = [
"Boston College",
"California",
"Clemson",
"Duke",
"Florida State",
"Georgia Tech",
"Louisville",
"Miami (FL)",
"North Carolina",
"NC State",
"Pittsburgh",
"SMU",
"Stanford",
"Syracuse",
"Virginia",
"Virginia Tech",
"Wake Forest"
]

const allowedOrgsCFP = [
"#1 Indiana",
"#2 Ohio State",
"#3 Georgia",
"#4 Texas Tech",
'#5 Oregon',
'#6 Ole Miss',
'#7 Texas A&M',
'#8 Oklahoma',
'#9 Alabama',
'#10 Miami (FL)',
'#11 Tulane',
'#12 James Madison'
]

const isSEC = organization === secOrg;
const isCFP = organization === cfpOrg;
const isACC = organization === accOrg;
const isB12 = organization === big12Org;
const isB10 = organization === big10Org;


//  Checks to see if referrer is from sec website, if so it sets a variable to true  //
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  const referrer = document.referrer;

  const embedded = window.top !== window.self;
  setIsEmbedded(embedded);

  if (!!userEmail) {
    setIsKnownUser(true);
  }

  if (referrer.includes("https://www.secsports.com/")) {
    if (source === "SECreports") {
      setIsFromSECReport(true);
    } else if (source === "SECarchive") {
      setIsFromSECArchive(true);
    }
  }
}, [userEmail]);

useEffect(() => {
  if (isEmbedded && (isFromSECReport) && !isKnownUser) {
    setActiveTab("published");
  }
  else if (isEmbedded && (isFromSECArchive) && !isKnownUser) {
    setActiveTab("archive");
  }
}, [isEmbedded, isFromSECReport, isFromSECArchive, isKnownUser]);


useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  const referrer = document.referrer;

  const embedded = window.top !== window.self;
  setIsEmbedded(embedded);

  if (!!userEmail) {
    setIsKnownUser(true);
  }

  if (referrer.includes("https://collegefootballplayoff.com/")) {
    if (source === "CFPreports") {
      setIsFromCFPReport(true);
    } else if (source === "CFParchive") {
      setIsFromCFPArchive(true);
    }
  }
}, [userEmail]);

useEffect(() => {
  if (isEmbedded && (isFromCFPReport) && !isKnownUser) {
    setActiveTab("published");
  }
  else if (isEmbedded && (isFromCFPArchive) && !isKnownUser) {
    setActiveTab("archive");
  }
}, [isEmbedded, isFromCFPReport, isFromCFPArchive, isKnownUser]);


useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  const referrer = document.referrer;

  const embedded = window.top !== window.self;
  setIsEmbedded(embedded);

  if (!!userEmail) {
    setIsKnownUser(true);
  }

  if (referrer.includes("https://theacc.com/")) {
    if (source === "ACCreports") {
      setIsFromACCReport(true);
    } else if (source === "ACCarchive") {
      setIsFromACCArchive(true);
    }
  }
}, [userEmail]);


useEffect(() => {
  if (isEmbedded && (isFromACCReport) && !isKnownUser) {
    setActiveTab("published");
  }
  else if (isEmbedded && (isFromACCArchive) && !isKnownUser) {
    setActiveTab("archive");
  }
}, [isEmbedded, isFromACCReport, isFromACCArchive, isKnownUser]);
// useEffect(() => {
//   const referrer = document.referrer;
//   const embedded = window.top !== window.self;
//   setIsEmbedded(embedded);

//   if (referrer.includes("https://big12sports.com/")) {
//     setIsFromB12(true);
//   }

//   if (!!userEmail) {
//     setIsKnownUser(true);
//   }  
// }, [userEmail]);


// useEffect(() => {
//   const params = new URLSearchParams(window.location.search);
//   const source = params.get("source");
//   const referrer = document.referrer;

//   if (source === "B12reports" && referrer.includes("https://big12sports.com/")) {
//     setIsFromB12Report(true);
//   }

//   const embedded = window.top !== window.self;
//   setIsEmbedded(embedded);

//   if (!!userEmail) {
//     setIsKnownUser(true);
//   }
// }, [userEmail]);

// useEffect(() => {
//   if (isEmbedded && isFromB12Report && !isKnownUser) {
//     setActiveTab("published");
//   }
// }, [isEmbedded, isFromB12Report, isKnownUser]);


// useEffect(() => {
//   const params = new URLSearchParams(window.location.search);
//   const source = params.get("source");
//   const referrer = document.referrer;

//   if (source === "B12archive" && referrer.includes("https://big12sports.com/")) {
//     setIsFromB12Archive(true);
//   }

//   const embedded = window.top !== window.self;
//   setIsEmbedded(embedded);

//   if (!!userEmail) {
//     setIsKnownUser(true);
//   }
// }, [userEmail]);

// useEffect(() => {
//   if (isEmbedded && isFromB12Archive && !isKnownUser) {
//     setActiveTab("published");
//   }
// }, [isEmbedded, isFromB12Archive, isKnownUser]);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  const referrer = document.referrer;

  const embedded = window.top !== window.self;
  setIsEmbedded(embedded);

  if (!!userEmail) {
    setIsKnownUser(true);
  }

  if (referrer.includes("https://big12sports.com/")) {
    if (source === "B12reports") {
      setIsFromB12Report(true);
    } else if (source === "B12archive") {
      setIsFromB12Archive(true);
    }
  }
}, [userEmail]);


useEffect(() => {
  if (isEmbedded && (isFromB12Report) && !isKnownUser) {
    setActiveTab("published");
  }
  else if (isEmbedded && (isFromB12Archive) && !isKnownUser) {
    setActiveTab("archive");
  }
}, [isEmbedded, isFromB12Report, isFromB12Archive, isKnownUser]);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  const referrer = document.referrer;

  const embedded = window.top !== window.self;
  setIsEmbedded(embedded);

  if (!!userEmail) {
    setIsKnownUser(true);
  }

  if (
  referrer.includes("https://bigten.org/") ||
  referrer.includes("https://bigten-stage.vercel.app/") ||
  referrer.includes("https://bigten-dev.vercel.app/")
)

{
    if (source === "B10reports") {
      setIsFromB10Report(true);
    } else if (source === "B10archive") {
      setIsFromB10Archive(true);
    }
  }
}, [userEmail]);


useEffect(() => {
  if (isEmbedded && (isFromB10Report) && !isKnownUser) {
    setActiveTab("published");
  }
  else if (isEmbedded && (isFromB10Archive) && !isKnownUser) {
    setActiveTab("archive");
  }
}, [isEmbedded, isFromB10Report, isFromB10Archive, isKnownUser]);

  const tabs = [
    { key: "summary", label: "Today's Summary" },
    { key: "window", label: "Current Window Breakdown" },
    { key: "draft", label: "Draft Report" },
    { key: "published", label: "Published Report" },
    { key: "exempt", label: "Long Term Player Status" },
    { key: "archive", label: "Archive Data" },
    { key: "playingtime", label: "Playing Time Data" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 450);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

//-----   SEC DATA  -----//
//////////////////////////
useEffect(() => {
  if (isSEC) {
    setLoadingDraft(true);
    import('./DrAHtEsC').then((mod) => {
      setSecDraftComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isSEC, userEmail]);       


useEffect(() => {

  if (isSEC) {
    setLoadingPublish(true);
    import('./PVBlisgEsC').then((mod) => {
      setSecPublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
  }
}, [isSEC, userEmail]);


useEffect(() => {

    setLoadingPublish(true);
    import('./PVBlisgEsC').then((mod) => {
      setPublicSecPublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
});


useEffect(() => {
  if (isSEC) {
    setLoadingExempt(true);
    import('./exemptMenu').then((mod) => {
      setSecExemptComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secExempt:', err);
        })
      .finally(() => {
        setLoadingExempt(false);
      });                      
  }
}, [isSEC, userEmail]);


useEffect(() => {

  if (isSEC) {
    setLoadingDraft(true);
    import('./SvWwAriEsc').then((mod) => {
      setSecSummaryComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isSEC, userEmail]); 


useEffect(() => {

  if (isSEC) {
    setLoadingDraft(true);
    import('./MiNDomEsC').then((mod) => {
      setSecWindowComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isSEC, userEmail]); 


useEffect(() => {
  if (!SecArchiveComponent && userEmail) {

  if (isSEC) {
      setLoadingDraft(true);
      import('./ArZhlUeeSc')
        .then((mod) => {
          setSecArchiveComponent(() => mod.default);
        })
        .catch((err) => {
          console.error('Failed to load secArchive:', err);
        })
        .finally(() => {
          setLoadingDraft(false);
        });
    }
  }
}, [SecArchiveComponent, isSEC, userEmail]);

useEffect(() => {

    setLoadingDraft(true);
    import('./ArZhlUeeSc').then((mod) => {
      setPublicSecArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12archive:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });                      
}, []);

useEffect(() => {

  if (isSEC) {
    setLoadingDraft(true);
    import('./secPlayingTime').then((mod) => {
      setSecPTComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isSEC, userEmail]); 


//-----   CFP DATA  -----//
//////////////////////////
useEffect(() => {
  if (isCFP) {
    setLoadingDraft(true);
    import('./DrAHtcfp').then((mod) => {
      setcfpDraftComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isCFP, userEmail]);       


useEffect(() => {

  if (isCFP) {
    setLoadingPublish(true);
    import('./PVBlisgcfp').then((mod) => {
      setcfpPublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
  }
}, [isCFP, userEmail]);


useEffect(() => {

    setLoadingPublish(true);
    import('./PVBlisgcfp').then((mod) => {
      setPubliccfpPublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
});


useEffect(() => {
  if (isCFP) {
    setLoadingExempt(true);
    import('./exemptMenucfp').then((mod) => {
      setcfpExemptComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secExempt:', err);
        })
      .finally(() => {
        setLoadingExempt(false);
      });                      
  }
}, [isCFP, userEmail]);


useEffect(() => {

  if (isCFP) {
    setLoadingDraft(true);
    import('./SvWwAricfp').then((mod) => {
      setcfpSummaryComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isCFP, userEmail]); 


useEffect(() => {

  if (isCFP) {
    setLoadingDraft(true);
    import('./MiNDomcfp').then((mod) => {
      setcfpWindowComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isCFP, userEmail]); 


useEffect(() => {
  if (!CFPArchiveComponent && userEmail) {

  if (isCFP) {
      setLoadingDraft(true);
      import('./ArZhlUecfp')
        .then((mod) => {
          setcfpArchiveComponent(() => mod.default);
        })
        .catch((err) => {
          console.error('Failed to load secArchive:', err);
        })
        .finally(() => {
          setLoadingDraft(false);
        });
    }
  }
}, [CFPArchiveComponent, isCFP, userEmail]);

useEffect(() => {

    setLoadingDraft(true);
    import('./ArZhlUecfp').then((mod) => {
      setPublicCFPArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12archive:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });                      
}, []);

useEffect(() => {

  if (isCFP) {
    setLoadingDraft(true);
    import('./cfpPlayingTime').then((mod) => {
      setcfpPTComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [isCFP, userEmail]); 



//-----   ACC DATA  -----//
//////////////////////////
useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./dRaHtCcA').then((mod) => {
      setAccDraftComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load accDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingPublish(true);
    import('./PvBlIsHCCa').then((mod) => {
      setAccPublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load accPublish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
  }
}, [ userEmail]);

useEffect(() => {

    setLoadingPublish(true);
    import('./PvBlIsHCCa').then((mod) => {
      setPublicAccPublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
});


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingExempt(true);
    import('./eXWpTaCc').then((mod) => {
      setAccExemptComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load accExempt:', err);
        })
      .finally(() => {
        setLoadingExempt(false);
      });                      
  }
}, [ userEmail]);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./SVwWAriCcA').then((mod) => {
      setAccSummaryComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./MiNDoWCcA').then((mod) => {
      setAccWindowComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./ArCGiVcAc').then((mod) => {
      setAccArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 

useEffect(() => {

    setLoadingDraft(true);
    import('./ArCGiVcAc').then((mod) => {
      setPublicAccArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12archive:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });                      
}, []);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./accPlayingTime').then((mod) => {
      setAccPTComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


//-----   BIG 12 DATA  -----//
//////////////////////////
useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./dPAHtBiT').then((mod) => {
      setBig12DraftComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12Draft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingPublish(true);
    import('./LvBLiSHBIt').then((mod) => {
      setBig12PublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12Publish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
  }
}, [ userEmail]);

useEffect(() => {

    setLoadingPublish(true);
    import('./LvBLiSHBIt').then((mod) => {
      setPublicB12PublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12Publish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
}, []);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingExempt(true);
    import('./eXWptWemvbiT').then((mod) => {
      setBig12ExemptComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load accExempt:', err);
        })
      .finally(() => {
        setLoadingExempt(false);
      });                      
  }
}, [ userEmail]);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./bITwElUSvwW').then((mod) => {
      setBig12SummaryComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./bITwElUMinoM').then((mod) => {
      setBig12WindowComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./ArZhlUeBit').then((mod) => {
      setBig12ArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 

useEffect(() => {

    setLoadingDraft(true);
    import('./ArZhlUeBit').then((mod) => {
      setPublicB12ArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12archive:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });                      
}, []);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./PtBiTmElU').then((mod) => {
      setBig12PTComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secDraft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 

//-----   b10 DATA  -----//
//////////////////////////
useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./DrHhtBio').then((mod) => {
      setBig10DraftComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Draft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingPublish(true);
    import('./PvBlisGBio').then((mod) => {
      setBig10PublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Publish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
  }
}, [ userEmail]);

useEffect(() => {

    setLoadingPublish(true);
    import('./PvBlisGBio').then((mod) => {
      setPublicB10PublishComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12Publish:', err);
        })
      .finally(() => {
        setLoadingPublish(false);
      });                      
}, []);

useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingExempt(true);
    import('./ExWptweMvBio').then((mod) => {
      setBig10ExemptComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Exempt:', err);
        })
      .finally(() => {
        setLoadingExempt(false);
      });                      
  }
}, [ userEmail]);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./bIoSvwMaRi').then((mod) => {
      setBig10SummaryComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Draft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./MimDOwbIo').then((mod) => {
      setBig10WindowComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Draft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./bIoArHIUe').then((mod) => {
      setBig10ArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Draft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 

useEffect(() => {

    setLoadingDraft(true);
    import('./bIoArHIUe').then((mod) => {
      setPublicB10ArchiveComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b12archive:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });                      
}, []);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingDraft(true);
    import('./PtBio').then((mod) => {
      setBig10PTComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load b10Draft:', err);
        })
      .finally(() => {
        setLoadingDraft(false);
      });            
  }
}, [ userEmail]); 

//----- INPUT FORMS -----//
//////////////////////////
useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';


  if (isKnown && !isSEC) {
    setLoadingInput(true);
    import('./EcSlNpvt').then((mod) => {
      setInputFormComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingInput(false);
      });                      
  }
}, [ isSEC, userEmail]);

useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';


  if (isKnown && !isCFP) {
    setLoadingInput(true);
    import('./cfplNpvt').then((mod) => {
      setInputFormComponentCFP(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingInput(false);
      });                      
  }
}, [ isCFP, userEmail]);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';


  if (isKnown && !isB12) {
    setLoadingInput(true);
    import('./IAiHPvtSOrw').then((mod) => {
      setInputFormB12Component(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load inputFormB12:', err);
        })
      .finally(() => {
        setLoadingInput(false);
      });                      
  }
}, [ isB12, userEmail]);

useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';


  if (isKnown && !isB10) {
    setLoadingInput(true);
    import('./IMpVtBio').then((mod) => {
      setInputFormB10Component(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load inputFormB10:', err);
        })
      .finally(() => {
        setLoadingInput(false);
      });                      
  }
}, [ isB10, userEmail]);


useEffect(() => {
  //const knownEmails = Array.from(emailTeamMap.keys());
  const isKnown = userEmail !== '';

  if (isKnown) {
    setLoadingInput(true);
    import('./cAClNptVhrn').then((mod) => {
      setACCInputFormComponent(() => mod.default);
    })
        .catch((err) => {
          console.error('Failed to load secPublish:', err);
        })
      .finally(() => {
        setLoadingInput(false);
      });                      
  }
}, [ userEmail]);



//   Get this Saturday's date to display as the week of variable   //
  const getNextSaturday = () => {
    const today = new Date();
    const dayNumber = today.getDay();  
    const saturdayNumber = 6;
    const dayDiff = saturdayNumber - dayNumber;
    const nextSaturday = new Date(today);
    nextSaturday.setDate(today.getDate() + dayDiff);
    const nameDay = nextSaturday.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
     return nameDay;
};

const gameDate = getNextSaturday();
      
//   Styling for the navigation bar   //
const tabStyle = (isActive) => ({
  padding: '10px 20px',
  borderBottom: isActive ? '3px solid #377a3a' : '3px solid transparent',
  fontWeight: isActive ? 'bold' : 'normal',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: '16px',
  fontFamily: 'Oswald, sans-serif'  
});  

//  Setting the content variable which will pulls from the different scripts. Content variable is the actual layouts of different pages   //
let content;
if ((userEmail && loading) || loadingDraft || loadingPublish || loadingInput || loadingExempt) {
  content = <p>Loading...</p>;
} else if (isSEC) {
    if (activeTab === 'draft') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : SecDraftComponent ? (
          <SecDraftComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    } else if (activeTab === 'published') {
 content = (    
  <div>     
        {loadingPublish ? (
          <p>Loading SEC Publish...</p>
        ) : SecPublishComponent ? (
          <SecPublishComponent title="" />
        ) : (
          <p>SEC Publish not available</p>
        )} 
  </div>
    );
    } else if (activeTab === 'exempt') {
  content = (    
    <div>     
          {loadingExempt ? (
            <p>Loading SEC Long Term Status...</p>
          ) : SecExemptComponent ? (
            <SecExemptComponent title="" />
          ) : (
            <p>SEC Player Status not available</p>
          )} 
    </div>
      );
    }  else if (activeTab === 'summary') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : SecSummaryComponent ? (
          <SecSummaryComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
 else if (activeTab === 'playingtime') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : SecPTComponent ? (
          <SecPTComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'window'){
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : SecWindowComponent ? (
          <SecWindowComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'archive') {
    content = (    
  <div>     
{loadingDraft ? (
  <p>Loading...</p>
) : SecArchiveComponent ? (
  <SecArchiveComponent />
) : (
  <p>Not available</p>
)}
  </div>
    );
    }
  }

else if (isCFP) {
    if (activeTab === 'draft') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : CFPDraftComponent ? (
          <CFPDraftComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    } else if (activeTab === 'published') {
 content = (    
  <div>     
        {loadingPublish ? (
          <p>Loading CFP Publish...</p>
        ) : CFPPublishComponent ? (
          <CFPPublishComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    );
    } else if (activeTab === 'exempt') {
  content = (    
    <div>     
          {loadingExempt ? (
            <p>Loading CFP Long Term Status...</p>
          ) : CFPExemptComponent ? (
            <CFPExemptComponent title="" />
          ) : (
            <p></p>
          )} 
    </div>
      );
    }  else if (activeTab === 'summary') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : CFPSummaryComponent ? (
          <CFPSummaryComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
 else if (activeTab === 'playingtime') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : CFPPTComponent ? (
          <CFPPTComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'window'){
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : CFPWindowComponent ? (
          <CFPWindowComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'archive') {
    content = (    
  <div>     
{loadingDraft ? (
  <p>Loading...</p>
) : CFPArchiveComponent ? (
  <CFPArchiveComponent />
) : (
  <p></p>
)}
  </div>
    );
    }
  }  
else if (isACC) {
    if (activeTab === 'draft') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : AccDraftComponent ? (
          <AccDraftComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    } else if (activeTab === 'published') {
 content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : AccPublishComponent ? (
          <AccPublishComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    } else if (activeTab === 'exempt') {
  content = (    
    <div>     
          {loadingExempt ? (
            <p>Loading ACC Long Term Status...</p>
          ) : AccExemptComponent ? (
            <AccExemptComponent title="" />
          ) : (
            <p>ACC Player Status not available</p>
          )} 
    </div>
      );
    }  else if (activeTab === 'summary') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : AccSummaryComponent ? (
          <AccSummaryComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
 else if (activeTab === 'playingtime') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : AccPTComponent ? (
          <AccPTComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }   
  else if (activeTab === 'window'){
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : AccWindowComponent ? (
          <AccWindowComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'archive') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : AccArchiveComponent ? (
          <AccArchiveComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  }

else if (isB12) {
    if (activeTab === 'draft') {
    content = (    
  <div>     
<div>     
        {loadingPublish ? (
          <p></p>
        ) : Big12DraftComponent ? (
          <Big12DraftComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>

  </div>
    );
    } else if (activeTab === 'published') {
 content = (    
  <div>     
        {loadingPublish ? (
          <p>Loading Big 12 Publish...</p>
        ) : Big12PublishComponent ? (
          <Big12PublishComponent title="" />
        ) : (
          <p>Big 12 Publish not available</p>
        )} 
  </div>
    );
    } else if (activeTab === 'exempt') {
  content = (    
    <div>     
          {loadingExempt ? (
            <p></p>
          ) : Big12ExemptComponent ? (
            <Big12ExemptComponent title="" />
          ) : (
            <p></p>
          )} 
    </div>
      );
    }  else if (activeTab === 'summary') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big12SummaryComponent ? (
          <Big12SummaryComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
 else if (activeTab === 'playingtime') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big12PTComponent ? (
          <Big12PTComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }   
  else if (activeTab === 'window'){
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big12WindowComponent ? (
          <Big12WindowComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'archive') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big12ArchiveComponent ? (
          <Big12ArchiveComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  }   

else if (isB10) {
    if (activeTab === 'draft') {
    content = (    
  <div>     
<div>     
        {loadingPublish ? (
          <p></p>
        ) : Big10DraftComponent ? (
          <Big10DraftComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>

  </div>
    );
    } else if (activeTab === 'published') {
 content = (    
  <div>     
          {loadingExempt ? (
            <p></p>
          ) : Big10PublishComponent ? (
            <Big10PublishComponent title="" />
          ) : (
            <p></p>
          )} 
  </div>
    );
    } else if (activeTab === 'exempt') {
  content = (    
    <div>     
          {loadingExempt ? (
            <p></p>
          ) : Big10ExemptComponent ? (
            <Big10ExemptComponent title="" />
          ) : (
            <p></p>
          )} 
    </div>
      );
    }  else if (activeTab === 'summary') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big10SummaryComponent ? (
          <Big10SummaryComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
 else if (activeTab === 'playingtime') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big10PTComponent ? (
          <Big10PTComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }   
  else if (activeTab === 'window'){
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big10WindowComponent ? (
          <Big10WindowComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  else if (activeTab === 'archive') {
    content = (    
  <div>     
        {loadingDraft ? (
          <p></p>
        ) : Big10ArchiveComponent ? (
          <Big10ArchiveComponent title="" />
        ) : (
          <p></p>
        )}
  </div>
    );
    }
  }     

   else if (allowedOrgsB12.includes(organization)) {
        content = (
      <div style={{ padding: '0px' }}>
        <div>     
        {loadingPublish ? (
          <p></p>
        ) : InputFormB12Component ? (
          <InputFormB12Component title="" />
        ) : (
          <p></p>
        )} 
        </div>
      </div>
        );
    } 

   else if (allowedOrgsACC.includes(organization)) {
        content = (
      <div style={{ padding: '0px' }}>
        <div>     
        {loadingPublish ? (
          <p></p>
        ) : ACCInputFormComponent ? (
          <ACCInputFormComponent title="" />
        ) : (
          <p></p>
        )} 
        </div>
      </div>
        );
    }     

   else if (allowedOrgsB10.includes(organization)) {
        content = (
      <div style={{ padding: '0px' }}>
        <div>     
        {loadingPublish ? (
          <p></p>
        ) : InputFormB10Component ? (
          <InputFormB10Component title="" />
        ) : (
          <p></p>
        )} 
        </div>
      </div>
        );
    }     

   else if (allowedOrgsSEC.includes(organization)) {
        content = (
          <div style={{ padding: '0px' }}>
              <div>     
        {loadingInput ? (
          <p>Loading Input Form...</p>
        ) : InputFormComponent ? (
          <InputFormComponent title="" />
        ) : (
          <p>Input Form not available</p>
        )}  
  </div>
          </div>
        );
    }        

   else if (allowedOrgsCFP.includes(organization)) {
        content = (
          <div style={{ padding: '0px' }}>
              <div>     
        {loadingInput ? (
          <p>Loading Input Form...</p>
        ) : InputFormComponentCFP ? (
          <InputFormComponentCFP title="" />
        ) : (
          <p>Input Form not available</p>
        )}  
  </div>
          </div>
        );
    }         
    

    //   This is the return section which determines what each user can actually see   //
    if (isSEC) {      
    return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          borderBottom: "2px solid #ccc",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        {isMobile ? (
          <div style={{
                display: "flex",
                justifyContent: "center", 
                width: "100%",
                marginBottom: "2px",
              }}
            >
            <button
              onClick={() => setDropdownOpen((prev) => !prev)}
              style={{
              ...tabStyle(true),
              color: "black", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
            }}
            >
              {tabs.find((t) => t.key === activeTab)?.label} ⌄
            </button>
            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)", 
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  zIndex: 10,
                  color: 'black',
                  width: "100%",
                  maxWidth: "300px",
                  display: "flex",
                  flexDirection: "column", 
                  alignItems: "center",
                }}
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => {
                      setActiveTab(tab.key);
                      setDropdownOpen(false);
                    }}
                    style={{
                    ...tabStyle(activeTab === tab.key),
                    color: "black", 
                  }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "20px" }}>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={tabStyle(activeTab === tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {activeTab !== "summary" &&
      activeTab !== "exempt" &&
      activeTab !== "window" &&
      activeTab !== "archive" &&
      activeTab !== "playingtime" ? (
        <>
          <h1
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "30px",
              fontFamily: "Oswald, sans-serif",
            }}
          >
          </h1>
          {content}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  );
      }

else if (isCFP) {      
    return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          borderBottom: "2px solid #ccc",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        {isMobile ? (
          <div style={{
                display: "flex",
                justifyContent: "center", 
                width: "100%",
                marginBottom: "2px",
              }}
            >
            <button
              onClick={() => setDropdownOpen((prev) => !prev)}
              style={{
              ...tabStyle(true),
              color: "black", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
            }}
            >
              {tabs.find((t) => t.key === activeTab)?.label} ⌄
            </button>
            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)", 
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  zIndex: 10,
                  color: 'black',
                  width: "100%",
                  maxWidth: "300px",
                  display: "flex",
                  flexDirection: "column", 
                  alignItems: "center",
                }}
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => {
                      setActiveTab(tab.key);
                      setDropdownOpen(false);
                    }}
                    style={{
                    ...tabStyle(activeTab === tab.key),
                    color: "black", 
                  }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "20px" }}>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={tabStyle(activeTab === tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {activeTab !== "summary" &&
      activeTab !== "exempt" &&
      activeTab !== "window" &&
      activeTab !== "archive" &&
      activeTab !== "playingtime" ? (
        <>
          <h1
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "30px",
              fontFamily: "Oswald, sans-serif",
            }}
          >
          </h1>
          {content}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  );
      }      

   else if (isACC) {      
    return  (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          borderBottom: "2px solid #ccc",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        {isMobile ? (
          <div style={{
                display: "flex",
                justifyContent: "center", 
                width: "100%",
                marginBottom: "2px",
              }}
            >
            <button
              onClick={() => setDropdownOpen((prev) => !prev)}
              style={{
              ...tabStyle(true),
              color: "black", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
            }}
            >
              {tabs.find((t) => t.key === activeTab)?.label} ⌄
            </button>
            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)", 
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  zIndex: 10,
                  color: 'black',
                  width: "100%",
                  maxWidth: "300px",
                  display: "flex",
                  flexDirection: "column", 
                  alignItems: "center",
                }}
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => {
                      setActiveTab(tab.key);
                      setDropdownOpen(false);
                    }}
                    style={{
                    ...tabStyle(activeTab === tab.key),
                    color: "black", 
                  }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "20px" }}>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={tabStyle(activeTab === tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {activeTab !== "summary" &&
      activeTab !== "exempt" &&
      activeTab !== "window" &&
      activeTab !== "archive" &&
      activeTab !== "playingtime" ? (
        <>
          <h1
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "30px",
              fontFamily: "Oswald, sans-serif",
            }}
          >
          </h1>
          {content}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  );
      }

   else if (isB12) {      
    return  (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          borderBottom: "2px solid #ccc",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        {isMobile ? (
          <div style={{
                display: "flex",
                justifyContent: "center", 
                width: "100%",
                marginBottom: "2px",
              }}
            >
            <button
              onClick={() => setDropdownOpen((prev) => !prev)}
              style={{
              ...tabStyle(true),
              color: "black", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
            }}
            >
              {tabs.find((t) => t.key === activeTab)?.label} ⌄
            </button>
            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)", 
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  zIndex: 10,
                  color: 'black',
                  width: "100%",
                  maxWidth: "300px",
                  display: "flex",
                  flexDirection: "column", 
                  alignItems: "center",
                }}
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => {
                      setActiveTab(tab.key);
                      setDropdownOpen(false);
                    }}
                    style={{
                    ...tabStyle(activeTab === tab.key),
                    color: "black", 
                  }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "20px" }}>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={tabStyle(activeTab === tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {activeTab !== "summary" &&
      activeTab !== "exempt" &&
      activeTab !== "window" &&
      activeTab !== "archive" &&
      activeTab !== "playingtime" ? (
        <>
          <h1
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "30px",
              fontFamily: "Oswald, sans-serif",
            }}
          >
          </h1>
          {content}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  );
      }
   else if (isB10) {      
    return  (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          borderBottom: "2px solid #ccc",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        {isMobile ? (
          <div style={{
                display: "flex",
                justifyContent: "center", 
                width: "100%",
                marginBottom: "2px",
              }}
            >
            <button
              onClick={() => setDropdownOpen((prev) => !prev)}
              style={{
              ...tabStyle(true),
              color: "black", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
            }}
            >
              {tabs.find((t) => t.key === activeTab)?.label} ⌄
            </button>
            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)", 
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  zIndex: 10,
                  color: 'black',
                  width: "100%",
                  maxWidth: "300px",
                  display: "flex",
                  flexDirection: "column", 
                  alignItems: "center",
                }}
              >
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => {
                      setActiveTab(tab.key);
                      setDropdownOpen(false);
                    }}
                    style={{
                    ...tabStyle(activeTab === tab.key),
                    color: "black", 
                  }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "20px" }}>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={tabStyle(activeTab === tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {activeTab !== "summary" &&
      activeTab !== "exempt" &&
      activeTab !== "window" &&
      activeTab !== "archive" &&
      activeTab !== "playingtime" ? (
        <>
          <h1
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "30px",
              fontFamily: "Oswald, sans-serif",
            }}
          >
          </h1>
          {content}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  );
      }     

    else if (allowedOrgsB12.includes(organization)) { 
    return (    
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : InputFormB12Component ? (
          <InputFormB12Component title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
     );    
    }

    else if (allowedOrgsACC.includes(organization)) { 
    return (    
      <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : ACCInputFormComponent ? (
          <ACCInputFormComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
      </div>
     );    
    }

    else if (allowedOrgsB10.includes(organization)) { 
    return (    
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : InputFormB10Component ? (
          <InputFormB10Component title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
     );    
    }

    else if (allowedOrgsSEC.includes(organization)) { 
    return (    
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : InputFormComponent ? (
          <InputFormComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
     );    
    }

    else if (allowedOrgsCFP.includes(organization)) { 
    return (    
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : InputFormComponentCFP ? (
          <InputFormComponentCFP title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
     );    
    }    

    else if (isFromSEC) {
  return (
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : SecPublicPublishComponent ? (
          <SecPublicPublishComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}
    else if (isFromB12Report) {
  return (
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : B12PublicPublishComponent ? (
          <B12PublicPublishComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}
    else if (isFromB12Archive) {
  return (
    <div>
<div>     
        {loadingDraft ? (
          <p></p>
        ) : B12PublicArchiveComponent ? (
          <B12PublicArchiveComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}
    else if (isFromB10Report) {
  return (
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : B10PublicPublishComponent ? (
          <B10PublicPublishComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}
    else if (isFromB10Archive) {
  return (
    <div>
<div>     
        {loadingDraft ? (
          <p></p>
        ) : B10PublicArchiveComponent ? (
          <B10PublicArchiveComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}

    else if (isFromSECReport) {
  return (
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : SecPublicPublishComponent ? (
          <SecPublicPublishComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}
    else if (isFromSECArchive) {
  return (
    <div>
<div>     
        {loadingDraft ? (
          <p></p>
        ) : SecPublicArchiveComponent ? (
          <SecPublicArchiveComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}

else if (isFromCFPReport) {

  return (
    <div>
      <div>
        {loadingPublish ? (
          <p></p>
        ) : CfpPublicPublishComponent ? (
          <CfpPublicPublishComponent title="" />
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

    else if (isFromCFPArchive) {
  return (
    <div>
<div>     
        {loadingDraft ? (
          <p></p>
        ) : CfpPublicArchiveComponent ? (
          <CfpPublicArchiveComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}


    else if (isFromACCReport) {
  return (
    <div>
<div>     
        {loadingPublish ? (
          <p></p>
        ) : AccPublicPublishComponent ? (
          <AccPublicPublishComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}
    else if (isFromACCArchive) {
  return (
    <div>
<div>     
        {loadingDraft ? (
          <p></p>
        ) : AccPublicArchiveComponent ? (
          <AccPublicArchiveComponent title="" />
        ) : (
          <p></p>
        )} 
  </div>
    </div>
  );
}



  else  {
  return (
    <div>
<div>     
  </div>
    </div>
  );
}

}
export default App;